import React, { FC, useContext, useEffect, useState } from "react";

import Button from "shared/ui/Button";
import { ID_TRACKER_PRICING, PaymentTypes, Pricing } from "shared/config/pricings";
import PageHeader from "components/PageHeader";
import ProfilCard from "components/ProfilCard/ProfilCard";
import logoIdTracker from "assets/img/ID Tracker.svg";
import { useNavigate } from "react-router-dom";
import { UserContext } from "features/account";
import { getSubscription } from "features/account";
import { changeSubscriptionOffer } from "features/payment";
import Modal from "shared/ui/Modal";
import { Button_Style, Button_Type } from "shared/ui/Button/Button";
import { mailTo } from "shared/lib/email_utils";
import Switch from "shared/ui/Switch";
import PriceCardV2 from "features/breaches/components/PriceCardV2";
import { ReactComponent as IconBack } from "assets/img/icons/icon_arrow-Right.svg";
import { ReactComponent as IconCheck } from "assets/img/icons/icon_status-Checked.svg";
import VideoFrame from "shared/ui/VideoFrame";
import { ReactComponent as IconFaq } from "assets/img/icons/icon_Faq.svg";
import DetailOffre from "components/DetailOffre";
import "./IDTrackerPricing.scss";

const iconProps = {
    fill: "#2f62ae",
    width: "20px",
};

type IDTrackerPricingProps = {
    isPage?: boolean;
    showOnlyOffers?: boolean;
    specificOffer?: Pricing[];
    offerLink?: string;
    hideSwitch?: boolean;
    onClick?: any;
    hideOffreGratuite?: boolean;
    isOuSide?: boolean;
};

const IDTrackerPricing: FC<IDTrackerPricingProps> = ({
     isPage= true,
     showOnlyOffers= false,
     specificOffer,
     offerLink,
     hideSwitch = false,
    onClick,
  hideOffreGratuite = true,
  isOuSide = false
}) => {
    const navigate = useNavigate();
    const { user, userType, getMe} = useContext(UserContext);
    const [isMonthActive, setIsMonthActive] = useState(true);
    // Offres 2026 : plus aucun abonnement mensuel à la vente. Tant que toutes
    // les offres récurrentes encore proposées sont annuelles, la bascule
    // mensuel/annuel n'a plus d'objet et afficherait un « /mois » trompeur.
    const onlyAnnualOffers = ID_TRACKER_PRICING
        .filter((plan) => !plan.freeze && plan.isRecurringPayment)
        .every((plan) => plan.annualOnly);

    const [offer, setOffer] = useState<any>();
    // Premium Hub (10) ou sa variante Famille (11) : une seule offre affichée
    // à la fois, la bascule remplace la grille.
    const [familleActive, setFamilleActive] = useState(false);
    const offrePrincipale = ID_TRACKER_PRICING.find(
        (plan) => plan.offreId === (familleActive ? 11 : 10) && !plan.freeze
    );

    const type = user?.type ?? 'individual';
    const [showModal, setShowModal] = useState<boolean>(false);
    // Offre visée quand le client en a déjà une : il ne s'agit alors pas de
    // souscrire — ce qui créerait un SECOND abonnement — mais de modifier le sien.
    const [planVise, setPlanVise] = useState<Pricing | null>(null);
    const [changementEnCours, setChangementEnCours] = useState(false);
    const [messageChangement, setMessageChangement] = useState<string | null>(null);
    const [showModalVideo, setShowModalVideo] = useState<boolean>(false);


    useEffect(() => {
        if (!isOuSide) {
            if (!user?.id) {
                getMe()
            }
            const getOffer = async () => {
                try {
                    const response = await getSubscription(type, user?.email);
                    setOffer(response.data.offrePurchase);
                } catch (error) {
                    console.log(error);
                }
            };

            // `offer` démarre à `undefined`, jamais à `null` : la comparaison
            // stricte d'origine (`offer === null`) n'était donc jamais vraie et
            // l'offre du client n'était JAMAIS chargée. Conséquences : l'offre
            // détenue n'était pas signalée, et le garde-fou qui devait empêcher
            // une seconde souscription ne se déclenchait pas.
            if (user && !offer) {
                getOffer();
            }
        }

    }, [user, user?.id, type, getMe, isPage]);

    const handleNext = (plan: Pricing) => {
        /*if (offerLink) {
            navigate(`${userType === "partner" ? "/professionnels" : "/particuliers"}/payment/id-tracker/${planIndex}/${isMonthActive ? "month" : "year"}`);
            // window.open(offerLink, "_blank", "noopener,noreferrer");
        }*/

        if (onClick) {
            onClick();
        }

        if (user?.id) {
            if (plan?.offreId === 1) {
                navigate(`${userType === "partner" ? "/professionnels" : "/particuliers"}/profil`);
            } else {
                if (plan?.head === PaymentTypes.ACCOMAPGNEMENT) {
                    navigate(`/particuliers/id-assistant/add/${plan?.offreId}`);
                } else {
                    navigate(`${userType === "partner" ? "/professionnels" : "/particuliers"}/payment/${plan?.headRoute}/${plan?.offreId}/${ plan.isRecurringPayment ? (plan.annualOnly || !isMonthActive ? "year" : "month") : '1fois'}`);
                }
            }
        } else {
            if (plan?.offreId === 1) {
                navigate(`${userType === "partner" ? "/professionnels" : "/particuliers"}/login`);
            } else {
                navigate(`/souscription/${plan?.headRoute}/${plan?.offreId}/${ plan.isRecurringPayment ? (plan.annualOnly || !isMonthActive ? "year" : "month") : '1fois'}`);
            }
        }

    };

    return (
        <div className="IDTrackerPricing">
            {isPage && (
                <PageHeader
                  title={"ID TRACKER"}
                  description={"le plan de souscription et d'activation"}
                  notification={user?.type === 'individual'}
                  protectAlert={user?.type === 'individual'}
                >
                </PageHeader>
            )}
            <div className={`${showOnlyOffers ? '' : 'content__body'}`}>
                <ProfilCard
                    title="ID Tracker"
                    // La fiche de l'offre porte désormais son propre titre : le
                    // bandeau « ID Tracker » et l'intitulé qui le suivait
                    // répétaient l'en-tête de page et repoussaient l'offre hors
                    // de l'écran. Ils ne restent que pour l'affichage d'une offre
                    // spécifique, qui n'a pas de fiche.
                    logo={!showOnlyOffers && specificOffer ? logoIdTracker : null}>
                    {!showOnlyOffers && specificOffer && (<h6>TROUVER le plan pour activer la suveillance Dark Web</h6>)}
                    {/* Bascule mensuel/annuel : sans objet pour les offres 2026,
                        vendues à l'année uniquement. */}
                    {specificOffer && !hideSwitch && !onlyAnnualOffers && (
                      <div className="center mb-3 d-flex justify-content-center gap-1">
                          {!specificOffer && (
                            <Switch isMonthActive={isMonthActive} setisMonthActive={setIsMonthActive} />
                          )}
                          {specificOffer && specificOffer[0].isRecurringPayment && (
                            <Switch isMonthActive={isMonthActive} setisMonthActive={setIsMonthActive} />
                          )}
                          <div>
                              {!isMonthActive && (
                                <span
                                  className={`isVerified tag tag-icon text-center tag-success ml-2 text-dark bg-success ${
                                    !isMonthActive ? "show" : ""
                                  }`}
                                >
                                    2 mois offerts
                                </span>
                              )}
                          </div>
                      </div>
                    )}
                    {/* Offre unique : Premium Hub, avec une bascule vers sa
                        variante Famille. Les deux sont au même prix et se
                        distinguent par le nombre de comptes couverts — les
                        afficher côte à côte forçait une comparaison sans objet. */}
                    {!specificOffer && offrePrincipale && (
                        <div className="IDTrackerPricing__offre">
                            <div className="IDTrackerPricing__bascule" role="tablist">
                                <button
                                    type="button"
                                    role="tab"
                                    aria-selected={!familleActive}
                                    className={!familleActive ? "est-actif" : ""}
                                    onClick={() => setFamilleActive(false)}>
                                    Pour moi
                                </button>
                                <button
                                    type="button"
                                    role="tab"
                                    aria-selected={familleActive}
                                    className={familleActive ? "est-actif" : ""}
                                    onClick={() => setFamilleActive(true)}>
                                    Pour ma famille
                                </button>
                            </div>

                            <DetailOffre
                                plan={offrePrincipale}
                                // L'offre déjà détenue ne se souscrit pas une
                                // seconde fois : le serveur le refuserait, autant
                                // le dire avant le clic.
                                actuelle={!!offer?.id && offer.id === offrePrincipale.offreId}
                                onChoisir={() => {
                                    // Un abonnement déjà en cours se MODIFIE : en
                                    // souscrire un second ferait deux prélèvements.
                                    if (offer?.id && offer.id > 1) {
                                        setPlanVise(offrePrincipale);
                                        setMessageChangement(null);
                                        setShowModal(true);
                                        return;
                                    }
                                    handleNext(offrePrincipale);
                                }}
                            />
                        </div>
                    )}

                    <div className="d-flex flex-row mb-1 flex-wrap gap-3 justify-content-center align-items-end ">
                        {false && !specificOffer && (
                          <>
                              {ID_TRACKER_PRICING.map((plan, index) => {
                                  if (plan.freeze) {
                                      return (<></>);
                                  }

                                  const isPlanFree = plan.offreId == 1;

                                  if (isPlanFree && hideOffreGratuite) {
                                      return (<></>);
                                  }

                                  return (
                                    <div className={`${showOnlyOffers ? "" : "w-30 min-w-30"}`} key={index}>
                                        <PriceCardV2
                                          showEnSavoirePlus={false}
                                          plan={plan}
                                          title={`${plan?.title ? plan?.title : ""}`}
                                          logo={logoIdTracker}
                                          isMonthActive={plan.annualOnly ? false : (plan.isRecurringPayment ? isMonthActive : false)}
                                          setIsMonthActive={plan.annualOnly ? undefined : (plan.isRecurringPayment ? setIsMonthActive : undefined)}
                                        >

                                            <div className="center">
                                                <Button
                                                  label={isPlanFree ? 'Offert' : offer?.id == plan?.offreId ? "Votre souscription" : "Souscrire"}
                                                  size="L"
                                                  onClick={() => {
                                                      if (offer?.id) {
                                                          if (offer?.id > 1) { // SI il a deja un abonnement actif
                                                              setPlanVise(plan);
                                                              setMessageChangement(null);
                                                              setShowModal(true);
                                                          } else {
                                                              return handleNext(plan);
                                                          }
                                                      } else {
                                                          return handleNext(plan);
                                                      }
                                                  }}
                                                  disabled={plan?.offreId == 1 || offer?.id == plan?.offreId}
                                                  style={Button_Style.OUTLINED}
                                                  type={Button_Type.LABEL}
                                                  icon={isPlanFree? null : offer?.id == plan?.offreId ?
                                                    <IconCheck className="PageHeader__icon" />
                                                    : <IconBack className="PageHeader__icon" fill={"#9FC1EF"} />}
                                                  className="text-primary bg-white"
                                                />
                                            </div>
                                        </PriceCardV2>
                                    </div>
                                  );
                              })}
                          </>
                        )}

                        {specificOffer && (
                          <>
                              {specificOffer.map((plan, index) => {
                                  return (
                                    <div className={`${showOnlyOffers ? '': 'w-40 min-w-40'}`} key={index}>
                                        <PriceCardV2
                                          showEnSavoirePlus={false}
                                          plan={plan}
                                          title={`${plan?.title ? plan?.title : ""}`}
                                          logo={logoIdTracker}
                                          isMonthActive={plan.isRecurringPayment? isMonthActive : undefined}
                                          setIsMonthActive={plan.isRecurringPayment? setIsMonthActive : undefined}
                                        >

                                            <div className="center">
                                                <Button
                                                  label={"Souscrire"}
                                                  size="L"
                                                  onClick={() => {
                                                      return handleNext(plan);
                                                  }}
                                                  style={Button_Style.OUTLINED}
                                                  type={Button_Type.LABEL}
                                                  icon={offer?.id == plan?.offreId ?
                                                    <IconCheck className="PageHeader__icon" fill={"#ffffff"} />
                                                    : <IconBack className="PageHeader__icon" fill={"#ffffff"} />}
                                                  className="text-white"
                                                />
                                            </div>
                                        </PriceCardV2>
                                    </div>
                                  );
                              })}
                          </>
                        )}

                    </div>
                    {!showOnlyOffers && (
                      <div className="d-flex justify-content-center align-items-center gap-05">
                          <u onClick={() => {
                              setShowModalVideo(true);
                          }} className="pointer">en savoir plus</u>
                          <IconFaq {...iconProps} />
                      </div>
                    )}
                </ProfilCard>
            </div>
            {showModal && (
              <Modal
                onClose={() => setShowModal(false)}
                isOpen={showModal}
                title="Abonnement existant"
                infoModal
                type="info"
              >
                <p>
                        Vous avez déjà l'abonnement <strong>{offer?.name}</strong> actif.
                        <br/>
                        Souhaitez-vous basculer sur <strong>{planVise?.title}</strong> ? Votre abonnement
                        actuel est modifié — vous n'en souscrivez pas un second — et la différence
                        éventuelle est calculée au prorata du temps restant.
                    </p>

                    {messageChangement && <p>{messageChangement}</p>}

                    <div className="d-flex flex-row flex-wrap justify-content-between align-items-center">
                        <Button
                            size="L"
                            onClick={() => navigate(`${type === 'individual' ?
                              '/particuliers/profil':
                              '/professionnels/profil'
                            }`)}
                            label="Voir mon abonnement"
                        >
                        </Button>
                        <Button
                            style={Button_Style.OUTLINED}
                            size="L"
                            disabled={changementEnCours || !planVise}
                            onClick={async () => {
                                if (!planVise) return;
                                setChangementEnCours(true);
                                const res = await changeSubscriptionOffer(planVise.title, planVise.offreId, type);
                                setChangementEnCours(false);
                                if (res?.success) {
                                    setMessageChangement(`Votre abonnement est désormais « ${planVise.title} ».`);
                                    setTimeout(() => navigate(`${type === 'individual' ? '/particuliers/profil' : '/professionnels/profil'}`), 1500);
                                } else {
                                    setMessageChangement(res?.error ?? "Le changement n'a pas pu être effectué. Merci de réessayer.");
                                }
                            }}
                            label={changementEnCours ? "..." : `Basculer sur : ${planVise?.title ?? ''}`}
                        >

                        </Button>
                    </div>
                </Modal>
            )}

            {showModalVideo &&
                <Modal
                    onClose={() => setShowModalVideo(false)} isOpen={showModalVideo} title={""} infoModal={true}
                    type={"info"}>
                    <VideoFrame
                        url="https://www.youtube.com/watch?v=XvoHvSI-Huo&t=7s"
                    >
                        <span className="text-primary bold">Surveillance Dark Web : </span>
                        <span className="text-danger">La plateforme ID Protect - prévenir l'usurpation d'identité</span>
                    </VideoFrame>
                </Modal>
            }

        </div>
    );
};
export default IDTrackerPricing;
